import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../../layouts/footer/Footer";
import ShopMain from "../../layouts/main/ShopMain";
import PRODUCT_CHUNK, { DEFAULT_LANGUAGE } from "../../utils/global_const";
import { useParams } from "react-router-dom";
import { ProductContext } from "../../context/ProductContext";
import Header from "../../layouts/header/Header";
import BestSellerMain from "../../layouts/main/product/BestSellerMain";

const SEOConfig = {
  en: {
    title: "Best Seller | SnusCo",
    description:
      "Explore our wide range of nicotine pouches and find your perfect match at SnusCo. Shop now and enjoy premium quality and variety.",
    keywords:
      "nicotine pouches, snus, buy snus online, best nicotine pouches, SnusCo shop",
    url: "https://www.snusco.at/en/nicotine-pouches",
    images: [
      "https://www.snusco.at/assets/default-category-image.jpg",
    ],
  },
  de: {
    title: "Bestseller | SnusCo",
    description:
      "Entdecken Sie unsere Bestseller – die beliebtesten Nikotinbeutel, ausgewählt von unseren Kunden. Finden Sie Ihren Favoriten unter den meistverkauften Snus-Produkten. Jetzt stöbern und genießen!",
    keywords:
      "Bestseller, Nikotinbeutel, beliebter Snus, SnusCo, beste Nikotinbeutel",
    url: "https://www.snusco.at/de/bestseller",
    images: [
      "https://www.snusco.at/assets/bestseller-category-image.jpg",
    ],
  },
};

const BestSeller = () => {
  const { t, i18n } = useTranslation();
  const { loadBestSellersBackend, products } = useContext(ProductContext);

  const [initialLoad, setInitialLoad] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!initialLoad) {
      // Proverava da li je ovo prvi put da se učitava
      loadBestSellersBackend();
      setInitialLoad(true); // Postavlja da je inicijalno učitavanje završeno
    }
  }, [initialLoad, products]);

  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);

  useEffect(() => {
    setSeo(SEOConfig[i18n.language] || SEOConfig[DEFAULT_LANGUAGE]);
  }, [i18n.language]);

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />

        {/* Open Graph slike - Primarna slika na prvom mestu */}
        {seo.images?.map((image, index) => (
          <meta key={index} property="og:image" content={image} />
        ))}

        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Header />
      <BestSellerMain />
      <Footer />
    </div>
  );
};

export default BestSeller;
